import { ButtonBase } from "@mui/material";
import { COLOR_BLACK, COLOR_WHITE } from "helpers/colors";
import { FONT_FAMILY_GRAPHIK } from "helpers/FONT";
import { SPACING, SPACING_HALF } from "helpers/spacings";
import { ChevronLeft, ChevronRight } from "mdi-material-ui";
import React from "react";

const navButtonStyle = {
  width: 38,
  height: 38,
  borderRadius: "50%",
  border: "1px solid rgba(0, 0, 0, 0.2)",
  color: COLOR_BLACK,
};

// Previous / next through a list of videos and a close button, below the video in a dialog.
// Without onPrevious and onNext (a single video, eg from the shot chart) only the close button shows.
export default function VideoPlayerDialogFooter({ index, total, onPrevious, onNext, onClose }) {
  const navigable = !!(onPrevious || onNext);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: SPACING_HALF,
        padding: `15px ${SPACING}`,
        borderTop: "1px solid rgba(0, 0, 0, 0.12)",
        backgroundColor: COLOR_WHITE,
        fontFamily: FONT_FAMILY_GRAPHIK,
      }}
    >
      {navigable && (
        <>
          <ButtonBase
            title="Previous"
            disabled={!onPrevious}
            onClick={onPrevious}
            style={{ ...navButtonStyle, opacity: onPrevious ? 1 : 0.3 }}
          >
            <ChevronLeft />
          </ButtonBase>
          <ButtonBase
            title="Next"
            disabled={!onNext}
            onClick={onNext}
            style={{ ...navButtonStyle, opacity: onNext ? 1 : 0.3 }}
          >
            <ChevronRight />
          </ButtonBase>
          {total > 0 && (
            <div style={{ fontSize: 14, color: "rgba(0, 0, 0, 0.54)", whiteSpace: "nowrap" }}>
              {index + 1} of {total}
            </div>
          )}
        </>
      )}
      <div style={{ marginLeft: "auto", display: "flex" }}>
        <CloseButton onClose={onClose} />
      </div>
    </div>
  );
}

// The dialog's black close pill, also on its own at the end of the reel header.
export function CloseButton({ onClose }) {
  return (
    <ButtonBase
      onClick={onClose}
      style={{
        padding: "8px 16px",
        borderRadius: 999,
        backgroundColor: COLOR_BLACK,
        color: COLOR_WHITE,
        fontFamily: FONT_FAMILY_GRAPHIK,
        fontSize: 14,
        fontWeight: 500,
      }}
    >
      Close
    </ButtonBase>
  );
}
